import { render, staticRenderFns } from "./MMultiSelectChoiceOptionGroup.vue?vue&type=template&id=4452b062"
import script from "./MMultiSelectChoiceOptionGroup.vue?vue&type=script&lang=js"
export * from "./MMultiSelectChoiceOptionGroup.vue?vue&type=script&lang=js"
import style0 from "./MMultiSelectChoiceOptionGroup.vue?vue&type=style&index=0&id=4452b062&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports